import { ShopInstance, UtilitiesInstance } from '@/store'
import { catchError } from '../../utils/catchError'

const order = {
  state: {
    items: [
      {
        amount: '',
        quantity: 1,
        description: ''
      }
    ],
    itemSubscription: [
      {
        price: '',
        quantity: 1,
        description: '',
        cycle: null
      }
    ],
    shipping: {
      amount: '',
      quantity: 1,
      description: 'frete'
    },
    total: {
      amount: null
    },
    customer: {
      document: '',
      email: '',
      home_phone: '',
      mobile_phone: '',
      name: ''
    },
    address: {
      city: '',
      country: '',
      neighborhood: '',
      number: '',
      state: '',
      street: '',
      complement: '',
      zip_code: '',
      show_address: false
    },
    createdOrderResponse: {
      id: '',
      payments: [
        {
          payment_method: '',
          status: ''
        }
      ],
      status: ''
    },
    createOrderError: {
      title: 'error.default.title',
      message: 'error.default.message',
      status: false
    },
    subscription: {
      interval: 'day',
      interval_count: '',
      start_at: '',
      setup: {
        amount: '',
        description: ''
      }
    },
    orderCode: ''
  },
  getters: {
    items (state) {
      return state.items
    },
    shipping (state) {
      return state.shipping
    },
    total (state) {
      return state.total
    },
    createdOrderResponse (state) {
      return state.createdOrderResponse
    },
    createOrderError (state) {
      return state.createOrderError
    },
    customer (state) {
      return state.customer
    },
    address (state) {
      return state.address
    },
    subscription (state) {
      return state.subscription
    },
    itemSubscription (state) {
      return state.itemSubscription
    },
    orderCode (state) {
      return state.orderCode
    },
    interval () {
      return ['day', 'week', 'month', 'year']
    },
    cycles () {
      return ['predefined', 'not_defined']
    }
  },
  mutations: {
    setItems (state, items) {
      state.items = items
    },
    'SET_CREATED_ORDER_RESPONSE' (state, value) {
      state.createdOrderResponse = value
    },
    'SET_ADDRESS' (state, res) {
      state.address.street = res.street
      state.address.neighborhood = res.district
      state.address.city = res.city
      state.address.state = res.state
      state.address.country = res.country
    },
    'SET_ERROR_STATUS' (state, value) {
      state.createOrderError.status = value
    },
    'RESET_ORDER_STATE' (state) {
      state.items = [
        {
          amount: '',
          quantity: 1,
          description: ''
        }
      ]
      state.itemSubscription = [
        {
          price: '',
          quantity: 1,
          description: '',
          cycle: null
        }
      ]
      state.shipping = {
        amount: '',
        quantity: 1,
        description: 'frete'
      }
      state.total = {
        amount: null
      }
      state.customer = {
        document: '',
        email: '',
        home_phone: '',
        mobile_phone: '',
        name: ''
      }
      state.address = {
        city: '',
        country: '',
        neighborhood: '',
        number: '',
        state: '',
        street: '',
        complement: '',
        zip_code: '',
        show_address: false
      }
      state.createdOrderResponse = {
        id: '',
        payments: [
          {
            payment_method: '',
            status: ''
          }
        ],
        status: ''
      }
      state.createOrderError = {
        title: 'error.default.title',
        message: 'error.default.message',
        status: false
      }
      state.subscription = {
        interval: 'day',
        interval_count: '',
        start_at: '',
        setup: {
          amount: '',
          description: ''
        }
      }
      state.orderCode = ''
    },
    'SET_ORDER_CODE' (state, value) {
      state.orderCode = value
    }
  },
  actions: {
    'SET_ITEMS' (context, params) {
      context.commit('SET_ITEMS', params)
    },
    'CREATE_ORDER' (context, params) {
      return ShopInstance.order.create(params.merchantId, params.accountId, params.body)
        .then(res => {
          if (res.status !== 'failed') {
            context.commit('SET_CREATED_ORDER_RESPONSE', res)
          }
          return Promise.resolve(res)
        })
        .catch((err) => catchError(err, context))
    },
    'CREATE_SUBSCRIPTION' (context, params) {
      return ShopInstance.subscription.create(params.merchantId, params.accountId, params.body)
        .then(res => {
          if (res.status !== 'failed') {
            context.commit('SET_CREATED_ORDER_RESPONSE', res)
          }
          return Promise.resolve(res)
        })
        .catch((err) => catchError(err, context))
    },
    'CREATE_ORDER_EMAIL_NOTIFICATION' (context, params) {
      return ShopInstance.order.createEmailNotification(params.merchantId, params.accountId, params.orderId)
        .then((res) => Promise.resolve(res))
        .catch(err => { catchError(err) })
    },
    'CREATE_SUBSCRIPTION_EMAIL_NOTIFICATION' (context, params) {
      return ShopInstance.subscription.createEmailNotification(params.merchantId, params.accountId, params.orderId)
        .then((res) => Promise.resolve(res))
        .catch(err => { catchError(err) })
    },
    'SET_ADDRESS' (context, value) {
      return UtilitiesInstance.commons.getAddressByZipCode(value)
        .then((res) => {
          context.commit('SET_ADDRESS', res)
          return Promise.resolve(res)
        })
        .catch(err => Promise.reject(err))
    },
    'RESET_ORDER_STATE' (context) {
      context.commit('RESET_ORDER_STATE')
    },
    'SET_ORDER_CODE' (context, value) {
      context.commit('SET_ORDER_CODE', value)
    }
  }
}

export default order
